import router from "./router";
import getPageTitle from "@/utils/get-page-title";
import { getUrlLocale } from '@/utils/url';
import Cookies from 'js-cookie';

const siteDataList = {
  en: '{"tws_id":2,"apply_site":"protal_en"}',
  zh: '{"tws_id":1,"apply_site":"protal"}'
}
const referrer = document.referrer

router.beforeEach(async (to, from, next) => {
  if (to.matched.length == 0) {
    // 如果路径中里有多语言 设置为路径中的语言
    let urlLocale = getUrlLocale()
    if (urlLocale && !referrer) {
      // 替换一下 因为语言是zh 但是中文版的路径是cn开头
      if(urlLocale == 'cn') {
        urlLocale = 'zh'
      }
      if (urlLocale != localStorage.getItem('currentLanguage')) {
        if (siteDataList[urlLocale]) {
          Cookies.set('siteData', siteDataList);
        }
        localStorage.setItem('currentLanguage', urlLocale);
        window.location.reload()
      }
    }
    

    next({ path: '/' })
  }

  document.title = getPageTitle(to.meta.title);


  next();
});

router.afterEach(() => { });
